import { Box, Button, Card, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from "@mui/material"
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { usePostBodyWithJwtMutation } from "src/redux/api/cabinet";
import { iLogout } from "src/redux/slices/app";
import { palette } from "src/theme/style/palette";
import { Alerting } from "src/views/components_cabinet/Alerting";

interface Props {
    mId: number
}

export const AdminRozygrish = ({ mId }: Props) => {
    const dispatch = useDispatch();
    const [getAlert, setgetAlert] = useState<{ type: number, msg: string } | undefined>(undefined);
    const nav = useNavigate();
    const [getDataBuy, { isLoading }] = usePostBodyWithJwtMutation();
    const [winnersDrawerState, setWinnersDrawerState] = useState(false);
    const [biletes, setBiletes] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 12, 23, 34, 45, 67, 78]);

    const updateWinnersDrawerState = () => {
        setWinnersDrawerState(!winnersDrawerState);
    }

    const closeWinnersDrawerState = () => {
        nav(0);
        setWinnersDrawerState(false);
    }

    const requestBuyBingo = async (data: any = []) => {
        const jwt = localStorage.getItem('jwt');

        try {
            const payload = await getDataBuy({
                body: data,
                route: 'send-bingo',
                jwt
            }).unwrap();
            setBiletes(payload?.number || []);
            // setItemsBingo(payload?.bingo || []);
            // setItemBingoData(payload);
            // dispatch(updBalances(payload));

            updateWinnersDrawerState()

        } catch (error: any) {
            if (error.data?.message === 'Unauthenticated.') dispatch(iLogout());
            setgetAlert({ type: 2, msg: error.data.message });
        }
    }

    const handleStart = (id: number) => {
        requestBuyBingo({ bingo: id });
    }

    return (
        <>

            {getAlert && <Alerting get={getAlert} />}

            <Button variant='contained'
                disabled={isLoading}
                onClick={() => handleStart(mId)}
            >Разыграть</Button>

            <Dialog
                maxWidth="lg"
                fullWidth
                open={winnersDrawerState}
                onClose={closeWinnersDrawerState}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    💰 Билеты-победители
                </DialogTitle>
                <DialogContent>
                    <Grid container minHeight={360} display='flex' alignItems='center' flex='wrap' justifyContent='space-around'>
                        {biletes?.map((e, i) => (
                            <Grid key={i} item xs={6} md={3} xl={2} sx={{ p: 1, position: 'relative' }}>
                                <Box
                                    sx={{
                                        border: '2px solid gold',
                                        borderRadius: '10px',
                                        background: palette.lightGray,
                                        position: 'relative',
                                        p: 2,
                                    }}
                                >
                                    <Typography
                                        textAlign="center"
                                        variant="h1"
                                    >
                                        {e}
                                    </Typography>

                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            top: 6,
                                            right: 6,
                                            backgroundColor: 'gold',
                                            color: 'black',
                                            borderRadius: '6px',
                                            fontSize: '12px',
                                            fontWeight: 'bold',
                                            px: 1,
                                            py: 0.5,
                                        }}
                                    >
                                        🏆
                                    </Box>
                                </Box>
                            </Grid>

                        ))}
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeWinnersDrawerState} autoFocus>
                        Закрыть
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
